import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
interface Props {
  name: string;
  count: number;
  href: string;
  bold: boolean;
  draftMode?: boolean;
}
export const CategoryLabel = t0 => {
  const $ = _c(13);
  const {
    name,
    count,
    href,
    bold,
    draftMode
  } = t0;
  const fontClass = bold ? "font-bold!" : "font-normal";
  if (draftMode) {
    const t1 = `text-sm ${fontClass}`;
    let t2;
    if ($[0] !== count) {
      t2 = <span className="text-xs text-muted-foreground ml-1">({count})</span>;
      $[0] = count;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== name || $[3] !== t1 || $[4] !== t2) {
      t3 = <span className={t1}>{name}{t2}</span>;
      $[2] = name;
      $[3] = t1;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  const t1 = `no-underline! hover:text-foreground transition-colors text-sm ${fontClass}`;
  let t2;
  if ($[6] !== count) {
    t2 = <span className="text-xs text-muted-foreground ml-1">({count})</span>;
    $[6] = count;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== href || $[9] !== name || $[10] !== t1 || $[11] !== t2) {
    t3 = <Link href={href} className={t1}>{name}{t2}</Link>;
    $[8] = href;
    $[9] = name;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};